import { useCallback } from 'react';
import type { GadgetData } from '@atlassian/jira-dashboard-common/src/types.tsx';
import { useFlagsService, type FlagConfiguration } from '@atlassian/jira-flags';
import { toFlagId } from '@atlassian/jira-flags/src/services/types';
import { IGNORED_GADGETS_FROM_COUNT_MAP } from '../../constants';
import messages from './messages';

export const gadgetLimitFlagAttributes: FlagConfiguration = {
	key: toFlagId('gadgetAddWithinLimitError'),
	type: 'error',
	title: messages.gadgetLimitFlagTitle,
	description: messages.gadgetLimitFlagDescription,
};

export const useAddGadgetWithinLimit = (
	limitIncludeIgnoredGadgets: number,
	limitExcludeIgnoredGadgets: number,
) => {
	const { showFlag } = useFlagsService();
	const canAddGadgetWithinLimit = useCallback<
		(gadgets: GadgetData[], gadgetModuleId: boolean) => boolean
	>(
		(gadgets, isGadgetIgnored) =>
			isGadgetIgnored
				? gadgets.length < limitIncludeIgnoredGadgets
				: gadgets.length < limitIncludeIgnoredGadgets &&
					gadgets.filter((e) =>
						typeof e.amdModule !== 'undefined'
							? !Object.values<string>(IGNORED_GADGETS_FROM_COUNT_MAP).includes(e.amdModule)
							: true,
					).length < limitExcludeIgnoredGadgets,
		[limitIncludeIgnoredGadgets, limitExcludeIgnoredGadgets],
	);

	const showGadgetLimitFlag = useCallback(() => {
		showFlag(gadgetLimitFlagAttributes);
	}, [showFlag]);

	return { canAddGadgetWithinLimit, showGadgetLimitFlag };
};
